import { Box, Flex, Heading, Image, ListItem, Text, UnorderedList } from "@chakra-ui/react";
import React from "react";
import { useTranslation } from "react-i18next";
import pyramidGraphic from "../../../../../assets/img/issb/pyramid-graphic.png";

function StepOne() {
  const { t } = useTranslation("translation", {
    keyPrefix: "issbPlan.planDetails.modals.stepOne"
  });

  return (
    <>
      <Heading size="lg" marginBottom={5}>
        {t("title")}
      </Heading>
      <Flex>
        <Box width="50%">
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("context")}
          </Text>
          <Text fontSize="lg" marginBottom={8}>
            {t("contextContent")}
          </Text>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("actions")}
          </Text>
          <UnorderedList marginLeft={8} marginBottom={8}>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionOne")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionTwo")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionThree")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("actionsContent.actionFour")}
              </Text>
            </ListItem>
          </UnorderedList>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("data")}
          </Text>
          <UnorderedList marginLeft={8} marginBottom={8}>
            <ListItem>
              <Text fontSize="lg">
                {t("dataContent.dataOne")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("dataContent.dataTwo")}
              </Text>
            </ListItem>
          </UnorderedList>
          <Text fontSize="xl" fontWeight="bold" marginBottom={2}>
            {t("stakeholders")}
          </Text>
          <UnorderedList marginLeft={8} marginBottom={4}>
            <ListItem>
              <Text fontSize="lg">
                {t("stakeholdersContent.stakeholderOne")}
              </Text>
            </ListItem>
            <ListItem>
              <Text fontSize="lg">
                {t("stakeholdersContent.stakeholderTwo")}
              </Text>
            </ListItem>
          </UnorderedList>
        </Box>
        <Flex width={"50%"} alignItems="center" flexFlow="column">
          <Box height={"20%"} />
          <Image height={"400px"} src={pyramidGraphic} marginBottom={2} />
          <Text fontSize="md" paddingInline={4}>
            {t("pyramidStructure")}
          </Text>
        </Flex>
      </Flex>
    </>
  );
}

export default StepOne;